export default __webpack_public_path__ + "static/tablet_KV01-0714d0e7032972ec234c92b3c7a791bf.mp4";